import React from 'react';
import classes from './scss/header.module.scss';
import Home from './../../Assets/images/Home_48px.png';
import World from './../../Assets/images/Globe Earth_64px.png';

const header = () => {
    return (
    <div>
        <div className={classes.topBar}></div>
        <div className={classes.grid}>
            <div className={classes.logo}></div>
        
            <div className={classes.address}>
                <div className={classes.images}>
                <img src ={Home} alt =" "/>
               <img src ={World} alt =" "/>
                </div>
                <div className={classes.text}>
                    <p>CYST Company Limited</p>
                    <p>95 Freetown Avenue, East Legon</p>
                    <p>Accra Ghana</p>
                    <p>www.teamcyst.com</p>
                    <p>mazzuma.teamcyst.com</p>

                </div>                
               
            </div>
        </div>
    </div>
    );
    
}

export default header;